import React from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  // Button,
  // UncontrolledCollapse
} from 'reactstrap';
import check from '../assets/tick.png';
import cross from '../assets/image-error.png';
import successActication from '../assets/success-activation.png';

const ModalConfirm = ({confirmIsOpen, confirmCloseNative, textSuccess, textError, type, confirmClose, confirmSuccess, textHeader, textReason, backdrop}) => {
  return (
    <Modal className="modal-message align-items-center justify-content-center" backdrop={backdrop ? backdrop : 'static'} size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
      <ModalBody className="pb-2" style={{minHeight: '120px'}}>
        <div className="d-flex flex-column align-items-center align-items-center">
          { 
            type === 'pin' 
            ?<img src={cross} alt='cross' style={{width: '70px', marginTop: '-1rem'}} />
            :type === 'success' ? <img src={successActication} alt='check' style={{width: '105px',marginBottom:'10px'}} />
            :<img src={cross} alt='cross' style={{width: '70px'}} />
          }
        </div>
      </ModalBody>
      <div>
        <span className={`btn-small d-block text-center mx-3 ${type === 'pin' ? 'mt-3' : 'mt-4'}`} id="toggler">
          {textHeader}
        </span>
        <center className="align-middle" style={{padding: '0 1.2rem'}}>
          { type === 'success' ?
          <div dangerouslySetInnerHTML={{ __html: textReason }} /> :
          <label className="small">{textReason}</label>
          }
        </center>
      </div>
      <ModalFooter className='text-center'>
        { type === 'success' 
          ?<button className="btn btn-primary btn-rounded2" style={{bottom: '6%'}} onClick={() => confirmCloseNative()}>Selesai</button>
          :<button className="btn btn-primary btn-rounded2" onClick={() => confirmClose()}>Tutup</button>
        }
      </ModalFooter>
    </Modal>
  );
}

export default ModalConfirm
